<template>
	<div>
		<h1>Partage d'éléments</h1>

        <div v-for="(l, key) in list" :key="key">
            <h2>{{names[key] || key}}</h2>

            <b-table striped hover :items="l" :fields="key == 'project' ? fields_uid : fields">
                <template v-slot:cell(share)="data">
                    <b-checkbox @change="setShare(data.index, data.item.share, key)" v-model="data.item.share"></b-checkbox>
                </template>
                <template v-slot:cell(automatic)="data">
                    <b-checkbox v-show="l[data.index].share == true" @change="setAutomatic(data.index, data.item.automatic, key)" v-model="data.item.automatic"></b-checkbox>
                </template>
            </b-table>
        </div>

	</div>
</template>

<script>
	import projects from "../services/projects.js";
	import elements from "../services/element.js";
    import library from "../services/library.js";
    import shares from "../services/shares.js"
	import store from "../store";
	
	export default {
        name: "share",
		components: {
		},
		data: function () {
			return {
                names: {
                    project: "Projets",
                    list: "Listes"
                },
                list: {},
                fields_uid: [{
                    key: "uid",
                    label: "Uid",
                    sortable: true
                },{
                    key: "libelle",
                    label: "Nom",
                    sortable: true
                },{
                    key: "share",
                    label: "Partage",
                    sortable: true
                },{
                    key: "automatic",
                    label: "Partage automatique",
                    sortable: true
                }],
                fields: [{
                    key: "libelle",
                    label: "Nom",
                    sortable: true
                },{
                    key: "share",
                    label: "Partage",
                    sortable: true
                },{
                    key: "automatic",
                    label: "Partage automatique",
                    sortable: true
                }]
			};
		},
		methods: {
            setAutomatic(index, automatic, type)
            {
                this.$set(this.list[type], index, this.list[type][index]);

                if (automatic)
                {
                    shares.post("get", type, this.list[type][index].uid, 
                        {
                            client_uid: store.state.user.client_uid,
                            client_name: store.state.client.nom,
                            name: this.list[type][index].libelle
                        },
                     true);
                }
                else
                    shares.delete("get", this.list[type][index].uid, true);
            },
            setShare(index, share, type)
            {
                this.$set(this.list[type], index, this.list[type][index]);

                if (share)
                {
                    shares.post("share", type, this.list[type][index].uid, {
                        client_uid: store.state.user.client_uid,
                        client_name: store.state.client.nom,
                        name: this.list[type][index].libelle
                    });
                }
                else
                {
                    if (this.list[type][index].automatic)
                    {
                        shares.delete("get", this.list[type][index].uid, true);
                        this.list[type][index].automatic = false;
                    }
                    shares.delete("share", this.list[type][index].uid);
                }
            },
            get: async function () {
                				
                var list_share = await shares.list("share");
                var list_get = await shares.list("get");

                var list_share_obj = {};
                for (var i = 0; i < list_share.length; i++)
                {
                    list_share_obj[list_share[i].element_uid] = list_share[i];
                }
                
                var list_get_obj = {};
                var list_get_obj_auto = {};
                for (var i = 0; i < list_get.length; i++)
                {
                    if (list_get[i].client_uid)
                        list_get_obj[list_get[i].element_uid] = list_get[i];
                    else
                        list_get_obj_auto[list_get[i].element_uid] = list_get[i];
                }

                var list = {};
                list["project"] = await projects.getAll();

                var list_list = await elements.getby_production(
					"list",
					null
                );
                list_list = list_list.element;
                list["list"] = [];
                for (var i = 0; i < list_list.length; i++)
                {
                    list["list"].push({
                        libelle: list_list[i].libelle,
                        uid: list_list[i].libelle
                    })
                }

                var types = ["rules", "db", "validation", "dashboard"];

                for (var i = 0; i < types.length; i++)
                {
                    var names = await library.getby_production(types[i]);
                    names = names.element;

                    list[types[i]] = [];
                    for (var j = 0; j < names.length; j++) {
                        if (types[i] == "project")
                        {
                            list[types[i]].push(
                                {
                                    libelle: names[j].name,
                                    uid: names[j].uid
                                }
                            );
                        }
                        else
                        {
                            list[types[i]].push(
                                {
                                    libelle: names[j].name,
                                    uid: names[j].name
                                }
                            );
                        }
                    }   
                }

                console.log("list_get")
                console.log(list_get)
                
                var keys = Object.keys(list);
                for (var key_i = 0; key_i < keys.length; key_i++)
                {
                    for (var i = 0; i < list[keys[key_i]].length; i++)
                    {
                        list[keys[key_i]][i].share = false;
                        if (list_share_obj[list[keys[key_i]][i].uid])
                            list[keys[key_i]][i].share = true;
                        list[keys[key_i]][i].automatic = false;
                        if (list_get_obj_auto[list[keys[key_i]][i].uid])
                            list[keys[key_i]][i].automatic = true;
                    }
                }

                this.list = list;
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.share) {
				this.$router.push({ name: "profile" });
            }

            await this.get();
		},
	};
</script>

<style></style>
